import { formatCnpj } from "../FormatCPForCNPJ";
import { normalizeDocumentNumber } from "../NormalizeDocumentNumber";
import { ValidateCPF } from "../ValidateCPF";

/**
 * Formata CPF, CNPJ ou Linha Telefônica baseado no input.
 * Suporta CNPJ alfanumérico (IN 2229/2024).
 *
 * @param value - String contendo o documento ou telefone (pode conter caracteres não alfanuméricos)
 * @returns String formatada de acordo com o tipo detectado:
 * - Telefone fixo (10 dígitos): (00) 0000-0000
 * - Telefone celular (11 dígitos): (00) 00000-0000
 * - CPF (até 11 dígitos): 000.000.000-00
 * - CNPJ (mais de 11 caracteres alfanuméricos): XX.XXX.XXX/XXXX-XX
 *
 * @example
 * ```ts
 * formatDocumentOrPhone('12345678900') // '123.456.789-00'
 * formatDocumentOrPhone('1140301234') // '(11) 4030-1234'
 * formatDocumentOrPhone('11987654321') // '(11) 98765-4321'
 * formatDocumentOrPhone('12345678000199') // '12.345.678/0001-99'
 * formatDocumentOrPhone('AB12345678CD01') // 'AB.123.456/78CD-01'
 * ```
 */
export function formatDocumentOrPhone(value: string): string {
  const hasAlpha = /[a-zA-Z]/.test(value);
  const cleaned = normalizeDocumentNumber(value);

  if (!cleaned) return "";

  // Contém letras → é CNPJ alfanumérico
  if (hasAlpha) {
    return formatCnpj(cleaned);
  }

  // Somente dígitos: lógica existente para telefone/CPF/CNPJ numérico
  if (cleaned.length === 10) {
    return cleaned
      .replace(/(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{4})(\d)/, "$1-$2");
  }

  if (cleaned.length === 11 && !ValidateCPF(cleaned)) {
    return cleaned
      .replace(/(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{5})(\d)/, "$1-$2");
  }

  if (cleaned.length <= 11) {
    return cleaned
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }

  return formatCnpj(cleaned);
}
